function getBasePathFromUrl(url) {
  const indexOfSecondSlash = url.indexOf("/", 1);
  if (indexOfSecondSlash === -1) {
    return url;
  }
  return url.substring(0, indexOfSecondSlash);
}
function stripBasePathFromString(url, basePath) {
  if (basePath === "") {
    return [url, true];
  }
  const basePathFromUrl = getBasePathFromUrl(url);
  if (basePathFromUrl === basePath) {
    const withoutBasePath = url.substr(basePath.length);
    return [withoutBasePath.length === 0 ? "/" : withoutBasePath, true];
  }
  return [url, false];
}
function stripBasePath(url, basePath) {
  if (typeof url === "string") {
    return stripBasePathFromString(url, basePath);
  }
  const { pathname, ...rest } = url;
  if (pathname === null || pathname === void 0) {
    return [url, false];
  }
  const [sanitizedPathname, isSanitized] = stripBasePathFromString(
    pathname,
    basePath
  );
  return [
    {
      pathname: sanitizedPathname,
      ...rest
    },
    isSanitized
  ];
}

export { getBasePathFromUrl, stripBasePath, stripBasePathFromString };
//# sourceMappingURL=basePath.mjs.map
